import React, { FC, useRef } from "react";
import { Loader } from "components";

import { useButtonEffect } from "components/button/hooks/useButtonEffect";
import classNames from "classnames";

interface IButton {
  text: string;
  disabled?: boolean;
  isSubmitting?: boolean;
}

export const SubmitButton: FC<IButton> = ({ text, disabled, isSubmitting }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const buttonEffect = useButtonEffect(buttonRef);

  return (
    <button
      className={classNames("button", [isSubmitting && "is-loading"])}
      style={buttonEffect}
      disabled={disabled}
      type="submit"
      ref={buttonRef}
    >
      <span className="button__text">{text}</span>
      <span className="button__loader">
        {isSubmitting && <Loader size="s" theme="light" />}
      </span>
    </button>
  );
};
